import React, { useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './TablaProducto.module.css';
import { v4 as uuidv4 } from 'uuid';
import Tooltip from '@mui/material/Tooltip';
import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
} from "reactstrap";
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalDetalleProducto from './ModalDetalleProducto';
function TablaProducto(props) {

    const { api = undefined } = props
    const marcas = props.marcas
    let fc_09ProductosMap = props.productosMap
    const emicioncertificadopromocion = props.emicioncertificadopromocion
    const { handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos } = api
    // const { productosMap, handdleProductoMap } = props.MapProductos
    const [id, setId] = React.useState()
    const [tipobebida, setTipoBebida] = React.useState('')
    const [contenidoalcoholico, setContenidoAlcoholico] = React.useState('')
    const [numeroanalisisgranel, setNumeroAnalisisGranel] = React.useState('')
    const [numeroanalisisbebida, setNumeroAnalisisBebida] = React.useState('')
    const [numerocertificado, setNumeroCertificado] = React.useState('')
    const [marca, setMarca] = React.useState('')
    const [ingrediente, setIngrediente] = React.useState('')
    const [numerolote, setNumeroLote] = React.useState('')
    const [numerolotegranel, setNumeroLoteGranel] = React.useState('')
    const [contenidonetobotella, setContenidoNetoBotella] = React.useState('')
    const [numerobotellas, setNumeroBotellas] = React.useState('')
    const [unidad, setunidad] = React.useState('')
    const [numerocajas, setNumeroCajas] = React.useState('')
    const [editar, setEditar] = React.useState(false)
    const [mostrar, setMostrar] = React.useState(false)

    const [productoMap, setproductoMap] = React.useState()


    const [detalleMarcas, setDetalleMarcas] = React.useState(false)
    const [dataDetalle, setDataDetalle] = React.useState([])
    const VerModalDetalle = (objeto) => {
        setDetalleMarcas(objeto)
    }


    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const columns = [
        {
            field: 'tipobebida', headerName: 'Tipo de bebida', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 200 : 300,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.tipobebida}`} arrow>
                    <label>{`${params.row.tipobebida} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'marca', headerName: 'Marca', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 180 : 280,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.marca}`} arrow>
                    <label>{`${params.row.marca} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'numeroanalisisgranel', headerName: 'No. de análisis granel', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 170 : 270,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.numeroanalisisgranel}`} arrow>
                    <label>{`${params.row.numeroanalisisgranel} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'contenidoalcoholico', headerName: '% Alc. Vol.', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 170 : 270,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.contenidoalcoholico}`} arrow>
                    <label>{`${params.row.contenidoalcoholico} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'numerolote', headerName: 'No. de lote envasado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 150 : 180,
            renderCell: (params) =>
            (
                <Tooltip title={`${params.row.numerolote}`} arrow>
                    <label>{`${params.row.numerolote} `}</label>
                </Tooltip>
            )
        },
        {
            field: 'detalle', headerName: 'Detalle', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: window.innerWidth < 1500 ? 120 : 175,
            renderCell: (params) => (
                <Fragment>
                    <button className={`btn btn-outline-secondary ms-1`} onClick={() => { setDataDetalle(params.row), setDetalleMarcas(true) }} >Detalle</button>
                </Fragment>

            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) => (
                <Fragment>
                    {fc_09ProductosMap?.length > 0 ? (
                        <Fragment>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonCorregir(params) }} >Corregir</button>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <button className={'btn btn-warning ms-0'} onClick={() => { botonEditar(params) }}>Editar</button>
                            <button className={'btn btn-danger ms-1'} onClick={() => { botonEliminar(params) }} >Eliminar</button>
                        </Fragment>)}
                </Fragment>

            )
        },
    ]
    const botonEliminar = async (params) => {
        handdleRemoveProductosPrev({ data: params.row })
    }
    const botonGuardar = async () => {
        if (mostrar) {
            if (contenidoalcoholico.toString().length > 0 && marca !== "0" &&
                marca !== "" && numerolote.length > 0 && contenidonetobotella.toString().length > 0 &&
                unidad !== "0" && unidad !== "" && numerobotellas.toString().length > 0 && numerocajas.toString().length > 0 &&
                numerolotegranel.length > 0 && numerocertificado.length > 0) {
                let dato = {
                    id: id, contenidoalcoholico: contenidoalcoholico, numeroanalisisgranel: numeroanalisisgranel, numerocertificado: numerocertificado,
                    marca: marca, numerolote: numerolote, contenidonetobotella: contenidonetobotella, numerobotellas: numerobotellas,
                    numerocajas: numerocajas, unidad: unidad, tipobebida: tipobebida, numeroanalisisbebida: numeroanalisisbebida,
                    ingrediente: ingrediente, numerolotegranel: numerolotegranel
                }
                handdleEditProductosPrev(dato)
                setMarca('')
                setContenidoAlcoholico('')
                setNumeroAnalisisGranel('')
                setNumeroCertificado('')
                setNumeroLote('')
                setContenidoNetoBotella('')
                setNumeroBotellas('')
                setNumeroCajas('')
                setNumeroLoteGranel('')
                setunidad("0")
                setTipoBebida('')
                setNumeroAnalisisBebida('')
                setIngrediente('')
                setEditar(false)
                setproductoMap([])
                setMostrar(false)
            } else {
                setvalidacion(true)
            }
        } else {
            setMostrar(true)
        }
    }
    const botonEditar = async (params) => {
        setMostrar(true)
        setId(params.row.id)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setNumeroAnalisisGranel(params.row.numeroanalisisgranel)
        setNumeroCertificado(params.row.numerocertificado)
        setMarca(params.row.marca)
        setNumeroLote(params.row.numerolote)
        setContenidoNetoBotella(params.row.contenidonetobotella)
        setNumeroBotellas(params.row.numerobotellas)
        setNumeroCajas(params.row.numerocajas)
        setunidad(params.row.unidad)
        setTipoBebida(params.row.tipobebida)
        setNumeroAnalisisBebida(params.row.numeroanalisisbebida)
        setIngrediente(params.row.ingrediente)
        setNumeroLoteGranel(params.row.numerolotegranel)
        setEditar(true)
    }

    let datos = []
    let [rows, setRows] = React.useState(productos)
    React.useEffect(() => {
        setRows(productos)
    }, [productos])

    const botonAgregar = async () => {
        if (mostrar) {
            if (contenidoalcoholico.toString().length > 0 && marca !== "0" &&
                marca !== "" && numerolote.length > 0 && contenidonetobotella.toString().length > 0 &&
                unidad !== "0" && unidad !== "" && numerobotellas.toString().length > 0 && numerocajas.toString().length > 0 &&
                numerolotegranel.length > 0 && numerocertificado.length > 0) {
                let dato = {
                    id: uuidv4(), contenidoalcoholico: contenidoalcoholico, numeroanalisisgranel: numeroanalisisgranel, numerocertificado: numerocertificado,
                    marca: marca, numerolote: numerolote, contenidonetobotella: contenidonetobotella, numerobotellas: numerobotellas, numerocajas: numerocajas,
                    unidad: unidad, tipobebida: tipobebida, numeroanalisisbebida: numeroanalisisbebida,
                    ingrediente: ingrediente, numerolotegranel: numerolotegranel
                }
                // setRows(...rows, dato)
                handdleProducto(dato)
                setMarca('')
                setContenidoAlcoholico('')
                setNumeroAnalisisGranel('')
                setNumeroCertificado('')
                setNumeroLote('')
                setContenidoNetoBotella('')
                setNumeroBotellas('')
                setNumeroCajas('')
                setNumeroLoteGranel('')
                setNumeroAnalisisBebida('')
                setTipoBebida('')
                setIngrediente('')
                setunidad("0")
                setMostrar(false)
            } else {
                setvalidacion(true)
            }
        } else {
            setMostrar(true)
        }
    }
    const botonCancelar = async () => {
        // handdleProductoMap([])
        setproductoMap([])
        setMostrar(false)
        setContenidoAlcoholico('')
        setNumeroAnalisisGranel('')
        setNumeroCertificado('')
        setMarca('')
        setNumeroLote('')
        setContenidoNetoBotella('')
        setNumeroBotellas('')
        setNumeroCajas('')
        setunidad("0")
        setNumeroLoteGranel('')
        setNumeroAnalisisBebida('')
        setTipoBebida('')
        setIngrediente('')
        setEditar(false)
    }
    const botonCorregir = async (params) => {
        setMostrar(true)
        const filtro = fc_09ProductosMap.filter(anexo => anexo.idfc41_anexoproducto === params.row.idfc41_anexoproducto)
        setproductoMap(filtro[0])
        // handdleProductoMap(filtro[0])
        // setproductoMap([])
        if (params.row.idfc41_anexoproducto) setId(params.row.idfc41_anexoproducto)
        else setId(params.row.idfc33_anexoproducto)
        setContenidoAlcoholico(params.row.contenidoalcoholico)
        setNumeroAnalisisGranel(params.row.numeroanalisisgranel)
        setNumeroCertificado(params.row.numerocertificado)
        setMarca(params.row.marca)
        setNumeroLote(params.row.numerolote)
        setContenidoNetoBotella(params.row.contenidonetobotella)
        setNumeroBotellas(params.row.numerobotellas)
        setNumeroCajas(params.row.numerocajas)
        setunidad(params.row.unidad)
        setNumeroAnalisisBebida(params.row.numeroanalisisbebida)
        setTipoBebida(params.row.tipobebida)
        setIngrediente(params.row.ingrediente)
        setNumeroLoteGranel(params.row.numerolotegranel)
        setEditar(true)
    }
    const obtenerAncho = () => {
        const anchoPantalla = window.innerWidth
        return anchoPantalla
    }
    return (
        <>
            <FormGroup>
                <div className='row align-items-center'>
                    {mostrar &&

                        <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <select value={tipobebida} onChange={e => setTipoBebida(e.target.value)}
                                        className={`form-select form-select-sm ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                            ? 'inputDenegado' : 'inputValidado') : ('')}`} >
                                        <option value="" >Seleccione un tipo de bebida</option>
                                        <option value="Bebida alcohólica preparada" >Bebida alcohólica preparada</option>
                                        <option value="Cóctel">Cóctel</option>
                                        <option value="Licor">Licor</option>
                                        <option value="Crema">Crema</option>
                                    </select>
                                    {tipobebida.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="number" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (
                                        productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')} `}
                                        id="floatingInput" placeholder='Contenido Alcohólico'
                                        value={contenidoalcoholico} onChange={e => setContenidoAlcoholico(e.target.value)}
                                        onWheel={event => event.currentTarget.blur()}
                                        title='Contenido Alcohólico'
                                    />
                                    <label htmlFor='floatingInput'>% Alc. Vol.</label>

                                    {contenidoalcoholico.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (
                                        productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        id="floatingInput" placeholder='No. de análisis de laboratorio'
                                        value={numeroanalisisbebida} onChange={e => setNumeroAnalisisBebida(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'><small>Análisis de laboratorio bebida con mezcal</small></label>
                                    <span className='text-danger' style={{ textAlign: 'justify' }}>{'Si su lote cuenta con más un análisis FQ indicarlos separados por una coma, Ej. NNMZ-1234, NNMZ-5678 ó OTR-A001234, NNMZ-9874.'}<br /></span>

                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>

                                </div>
                            </div>

                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <select className={`form-select ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        value={marca}
                                        onChange={e => setMarca(e.target.value)}
                                    >
                                        <option value="0">Seleccione una marca</option>
                                        {
                                            marcas?.map((opcion, i) => (
                                                // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                <option value={`${opcion.marca}`} >{`${opcion.marca}`}</option>
                                                // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                            ))
                                        }
                                    </select>
                                    {marca === "0" || marca === "" ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado NOM'
                                        value={ingrediente} onChange={e => setIngrediente(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>Ingrediente/sabor</label>
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de lote envasado'
                                        value={numerolote} onChange={e => setNumeroLote(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>No. de lote envasado</label>
                                    {numerolote.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className="form-floating mb-3">
                                    <input type="number" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Contenido neto x botella'
                                        value={contenidonetobotella} onChange={e => setContenidoNetoBotella(e.target.valueAsNumber)}
                                        onWheel={event => event.currentTarget.blur()}
                                    />
                                    <label htmlFor='floatingInput'>Contenido neto x botella</label>
                                    {unidad === "mL" ? (
                                        contenidonetobotella < 20 || contenidonetobotella > 5000 ?
                                            (<span className='text-danger'>El rango debe de ser de 20 ml a 5000 ml</span>) : ''
                                    ) : unidad === 'L' ? (contenidonetobotella < .02 || contenidonetobotella > 5 ?
                                        (<span className='text-danger'>El rango debe de ser de .02 L a 5 L</span>) : '') :
                                        unidad === 'cL' ? (contenidonetobotella < 2 || contenidonetobotella > 500 ?
                                            (<span className='text-danger'>El rango debe de ser de 2 cl a 500 cl</span>) : '') : ''}
                                    {contenidonetobotella.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>

                                </div>
                            </div>
                            <div className='col-md-1'>
                                <div className="form-floating mb-2">

                                    <select onChange={e => setunidad(e.target.value)}
                                        value={unidad}
                                        className={`form-select form-select-sm ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                            ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    >
                                        <option value="0" >Unidad</option>
                                        <option value="mL">mL</option>
                                        <option value="L">L</option>
                                        <option value="cL">cL</option>
                                    </select>
                                    {unidad === "0" || unidad === "" ? <>
                                        <span className='text-danger'>Campo obligatorio</span> <br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-3">
                                    <input type="number" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de batellas'
                                        value={numerobotellas} onChange={e => setNumeroBotellas(e.target.valueAsNumber)}
                                        onWheel={event => event.currentTarget.blur()}
                                    />
                                    <label htmlFor='floatingInput'>No. de botellas</label>
                                    {numerobotellas.toString().length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-3">
                                    <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de cajas'
                                        value={numerocajas} onChange={e => setNumeroCajas(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>No. de cajas</label>
                                    {numerocajas.toString().length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <h6 className={`text-center ${estilos.labelNaranja}`}>DESCRIPCIÓN DEL MEZCAL UTILIZADO</h6>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" min='0' className={`form-control ${productoMap?.productocheck !== undefined ? (
                                        productoMap?.productocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        id="floatingInput" placeholder='No. de análisis de laboratorio'
                                        value={numeroanalisisgranel} onChange={e => setNumeroAnalisisGranel(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'><small>Análisis de laboratorio mezcal a granel</small></label>
                                    {numeroanalisisgranel.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger' style={{ textAlign: 'justify' }}>{'Si su lote cuenta con más un análisis FQ indicarlos separados por una coma, Ej. NNMZ-1234, NNMZ-5678 ó OTR-A001234, NNMZ-9874. '}<br /></span>

                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-2">
                                    <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de certificado NOM'
                                        value={numerocertificado} onChange={e => setNumeroCertificado(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>No. de certificado NOM vigente</label>
                                    {numerocertificado.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-floating mb-3">
                                    <input type="text" className={`form-control ${productoMap?.productocheck !== undefined ? (productoMap?.productocheck
                                        ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='No. de lote envasado'
                                        value={numerolotegranel} onChange={e => setNumeroLoteGranel(e.target.value)}
                                    />
                                    <label htmlFor='floatingInput'>No. de lote a granel</label>
                                    {numerolotegranel.length <= 0 ? <>
                                        <span className='text-danger'>Campo obligatorio</span><br /></> : ''}
                                    <span className='text-danger'>{productoMap?.productocheck ? productoMap?.producto : ''}</span>
                                </div>
                            </div>
                        </div>}
                </div>
            </FormGroup>
            {!editar ?
                <Fragment>
                    {fc_09ProductosMap?.length === 0 ? (
                        <Fragment>
                            <div className='col-md-3'></div>
                            <div className='text-center'>
                                <button className='btn btn-success col-md-3' onClick={botonAgregar}>Agregar producto</button>
                            </div>
                            <br />
                        </Fragment>) : ''}
                </Fragment>
                : (
                    <Fragment>
                        <div className='row'>
                            {/* <div className='text-center'> */}
                            <div className='col-md-3'></div>
                            <button className={'btn btn-success col-md-3 ms-0'} onClick={botonGuardar}>Guardar producto</button>
                            {/* </div> */}
                            {/* <div className='text-center'> */}
                            <button className={'btn btn-dark col-md-3 ms-2'} onClick={botonCancelar}>Cancelar</button>
                            {/* </div> */}

                        </div>
                        <br />
                    </Fragment>
                )}
            <br />
            <hr />
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
            <div className='row'>
                <div className='col-12 text-center'>
                    <div style={{ height: (130 + (rows?.length * 50)), width: obtenerAncho()<=2050?'100%':'75%', color: 'black', alignItems: 'center' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}

                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                position: 'relative',
                                alignContent: 'center',
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            {detalleMarcas && <ModalDetalleProducto api={{ VerModalDetalle, dataDetalle, detalleMarcas }} />}
        </>
    )
}
export default TablaProducto